import { TextField, useTheme } from '@mui/material';

import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

interface CreditCardHolderInputProps {
  registerFunc: () => object;
  isLoading?: boolean;
  isError?: boolean;
  helperText?: string;
}

export const CreditCardHolderInput: FC<CreditCardHolderInputProps> = ({
  registerFunc,
  isLoading = false,
  isError = false,
  helperText = '',
}) => {
  const theme = useTheme();

  return (
    <TextField
      id='credit-card-holder'
      label={<FormattedMessage id='my_credit_cards.card_holder' />}
      disabled={isLoading}
      InputProps={{
        sx: {
          color: theme.palette.grey[80],
        },
      }}
      error={isError}
      helperText={helperText}
      {...registerFunc()}
    />
  );
};
